import React, { FC, useEffect, useState, memo } from 'react';
import moment from 'moment';
import { IEvents, MapTemplate } from 'types';
import {
  getTimeWithTimeZone,
  getTimeDifference,
} from 'utils/helpers/momentTime';
import styles from 'components/common/calendar/index.module.scss';
import { getUpperCase, getUrl } from 'utils/helpers/whatsNextRoom';
import MobileService from 'services/mobile';
import root from './index.module.scss';

const PX_IN_MIN = MobileService.isMobile ? 3.33 : 2.66;

interface IEventProps {
  day: moment.Moment;
  event: IEvents;
  diff: number;
  daysToShow: number;
  mapTemplate: MapTemplate;
}

const Event: FC<IEventProps> = ({
  event,
  day,
  diff,
  daysToShow,
  mapTemplate,
}) => {
  const startTime = getTimeWithTimeZone(event.startTimeStr || '00:00', 'HH:mm');
  const endTime = getTimeWithTimeZone(event.endTimeStr || '00:00', 'HH:mm');
  const [eventHeight, setEventHeight] = useState<number>(
    moment(`${endTime} ${moment(day).format('MMM, D')}`).diff(
      `${startTime} ${moment(day).format('MMM, D')}`,
      'minutes'
    ) * PX_IN_MIN
  );

  useEffect(() => {
    const diffInTime = getTimeDifference(day, startTime, endTime);
    const height = diffInTime * PX_IN_MIN;
    setEventHeight(height);
  }, [event, day, endTime, startTime]);

  return (
    <div className={`${styles.cell} ${root.cell}`}>
      <div style={{ height: eventHeight, top: `${PX_IN_MIN * diff}px` }}>
        {daysToShow === 1 ? (
          <div className={root.full}>
            <div>
              <div>
                <p>{getUpperCase(event.subject)},</p>
                <a href={event.title}>{event.title}</a>
              </div>
              <span>{`${moment(startTime, 'HH:mm').format('LT')} - ${moment(
                endTime,
                'HH:mm'
              ).format('LT')}`}</span>
            </div>
            <img
              src={getUrl(event.subject, mapTemplate)}
              className={root.eventImage}
              alt={event.subject}
            />
          </div>
        ) : (
          <div className={root.short}>
            <img
              src={getUrl(event.subject, mapTemplate)}
              className={root.eventImage}
              alt={event.subject}
            />
            <p>{getUpperCase(event.subject)}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(Event);
